module.exports = __webpack_public_path__ + "img/xaklogin1.5f42e98b.png";